import type { StreamingInitializeResponse } from '../../models/entities/streaming.model';

/** Converts the initialize response into the WebRTC playback URL. */
export function buildStreamingWebrtcUrl(
  response: StreamingInitializeResponse,
): string | undefined {
  const host = response.host
    ?.trim()
    .replace(/^https?:\/\//i, '')
    .replace(/\/.*$/, '')
    .replace(/:\d+$/, '');
  const path = response.path?.trim().replace(/^\/+|\/+$/g, '');
  const port = Number(response.ports?.webrtc);

  if (
    !host ||
    !path ||
    !Number.isInteger(port) ||
    port <= 0 ||
    port > 65_535
  ) {
    return undefined;
  }

  return `https://${host}:${port}/${path}`;
}

/** Removes userinfo from an RTSP URL before POST /legacy/initialize. */
export function stripRtspUserinfo(url: string): string {
  return url.replace(/^(rtsp:\/\/)[^/@]+@/i, '$1');
}

/** True when playback should negotiate WHEP instead of using `<video src>`. */
export function isWhepPlaybackUrl(url: string | null | undefined): boolean {
  if (!url?.trim()) {
    return false;
  }
  const trimmed = url.trim();
  return /^https?:\/\//i.test(trimmed) && !/\.(mp4|webm|m3u8)(\?|#|$)/i.test(trimmed);
}
